import LanguageContext from './LanguageContext';
import { useContext } from 'react';

function useActiveLanguage() {
  const context = useContext(LanguageContext);
  return context.activeLanguage;
}

export default useActiveLanguage;
